import { render, staticRenderFns } from "./CompanyLanding.vue?vue&type=template&id=0cd53566&scoped=true&"
import script from "./CompanyLanding.vue?vue&type=script&lang=js&"
export * from "./CompanyLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd53566",
  null
  
)

export default component.exports